/* eslint-disable no-param-reassign */
import axios, { AxiosInstance, InternalAxiosRequestConfig } from "axios";
import { enqueueSnackbar } from "notistack";

// const API_URL = process.env.REACT_APP_API_URL || "https://exbr-server-production.up.railway.app";
const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3333";

export const api: AxiosInstance = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem("@exbr:token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  },
);

api.interceptors.response.use(
  response => response,
  error => {
    if (error?.response?.status === 429) {
      enqueueSnackbar(
        "Muitas requisições em pouco tempo. Aguarde um momento e tente novamente.",
        { variant: "warning", preventDuplicate: true },
      );
    }
    return Promise.reject(error);
  },
);
